
// FancyDressActivity
import React from 'react';
import FieldTrip62025 from 'views/FieldTrip62025';

const FancyDressActivityPage = () => {
  return <FieldTrip62025/>;
};

export default FancyDressActivityPage;